package fr.frux.core.database

import app.cash.sqldelight.db.SqlDriver

/**
 * Pas de cache offline sur web à ce stade : le driver web worker de SQLDelight impose une API
 * async et un packaging npm, chantier séparé de l'epic #8. La fourniture Metro étant paresseuse,
 * le graphe js reste valide tant qu'aucun consommateur n'injecte la base sur cette cible.
 */
actual fun createDatabaseDriver(): SqlDriver = throw UnsupportedOperationException("Cache local non supporté sur web")
